import React from 'react';
import Grid from 'atoms/Layout/Grid/Grid';
import Stack from 'atoms/Layout/Stack/Stack';
import ResourceArticleSearchInput from 'molecules/ResourceArticleSearchInput/ResourceArticleSearchInput';
import ResourceCategoriesDropdowns from './ResourceCategoriesDropdowns';

interface ResourceCategoriesMenuProps {
  preSetCategory?: string;
  preSetSubCategory?: string;
}

const ResourceCategoriesMenu = ({ preSetCategory, preSetSubCategory }: ResourceCategoriesMenuProps): JSX.Element => {
  return (
    <Grid totalColumns={1}>
      <Stack
        justify='space-between'
        align='flex-start'
        gap='spacing-4xl'
        gapSm='spacing-xl'
        directionXl='column'
      >
        <ResourceCategoriesDropdowns
          preSetCategory={preSetCategory}
          preSetSubCategory={preSetSubCategory}
        />
        <ResourceArticleSearchInput />
      </Stack>
    </Grid>
  );
};

export default ResourceCategoriesMenu;
